(function () {
  // Shopify's Admin API blocks editing shop.money_format directly (406 on
  // PUT /shop.json), and the theme prices come from 30+ different
  // liquid files via the money / money_with_currency filters, all
  // pulling that same store-level format ("Rs. {{amount}}" /
  // "Rs. {{amount}} INR"). Rather than hand-edit every file, swap the
  // rendered text once here: "Rs. 150.00 INR" / "Rs. 150.00" -> "₹150.00".
  var PATTERN = /Rs\.?\s*([\d,]+(?:\.\d{2})?)(\s*INR)?/g;

  function replaceInNode(node) {
    if (node.nodeType === Node.TEXT_NODE) {
      if (node.nodeValue.indexOf('Rs') === -1) return;
      var next = node.nodeValue.replace(PATTERN, '₹$1');
      if (next !== node.nodeValue) node.nodeValue = next;
      return;
    }
    if (node.nodeType !== Node.ELEMENT_NODE) return;
    var tag = node.tagName;
    if (tag === 'SCRIPT' || tag === 'STYLE' || tag === 'TEXTAREA' || tag === 'INPUT') return;
    for (var child = node.firstChild; child; child = child.nextSibling) {
      replaceInNode(child);
    }
  }

  var scheduled = false;
  function runSoon() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      replaceInNode(document.body);
    });
  }

  if (document.body) {
    replaceInNode(document.body);
  } else {
    document.addEventListener('DOMContentLoaded', function () { replaceInNode(document.body); });
  }

  // covers cart drawer/page AJAX updates, quick-add modals, quantity
  // changes — anything that re-renders price text after the initial load
  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var m = mutations[i];
      if (m.type === 'characterData' && m.target.nodeValue && m.target.nodeValue.indexOf('Rs') !== -1) {
        runSoon();
        return;
      }
      if (m.addedNodes && m.addedNodes.length) {
        runSoon();
        return;
      }
    }
  });
  if (document.body) {
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
  }
})();
